import { ICategoryFilter, IFilters } from "reducer/category.reducer";
import { CUSTOM_SIZES } from "./customSizesConstants";

export const FILTER_LABEL_MAP = {
  tier0: "Category",
  tier1: "Category",
  tier2: "Category",
  tier3: "Category",
  availabilities: "Availability",
  sizes: "Size",
  manufacturers: "Brand",
  prices: "Price",
  make: "Make",
  model: "Model",
  engine: "Engine",
  description: "Product",
  phrase: "Phrase",
  fitments: "Fitment",
  diameters: "Diameter",
  widths: "Width",
  offsets: "Offset",
  Color: "Color",
  boltPatterns: "Bolt Patterns",
  oilGrades: "Oil Grades",
  oilViscosities: "Oil Viscosities",
  oilVolumes: "Oil Volumes",
  productTags: "Product Grade",
  merchandiseColors: "Color",
  merchandiseSizes: "Size",
  airFreshenerColors: "Air Freshener Color",
  airFreshenerScents: "Scents",
  customTireSize: "Custom Tire Size",
  customWheelSize: "Custom Wheel Size",
};

export const VALID_QUERY_FILTERS: (keyof ICategoryFilter)[] = [
  "availabilities", "manufacturers", "prices", "fitments", "sizes",
  "seasons", "diameters", "widths", "offsets", "colors", "boltPatterns",
  "oilGrades", "types", "oilVolumes", "oilViscosities", "productTags",
  "description", "merchandiseColors", "merchandiseSizes",
  "airFreshenerColors", "airFreshenerScents",
];

export const VALID_FILTER_FOR_SUMMARY: (keyof IFilters)[] = [
  ...VALID_QUERY_FILTERS,
  ...CUSTOM_SIZES,
];
